@if (docType === 'JobDetail' && idFound) {
<app-job-detail-preview [ordId]="docId">
  <a
    class="td-link ml-5"
    [routerLink]="['/orders', docId]"
    [queryParamsHandling]="preserveQueryParams ? 'preserve' : ''"
  >
    @if (!hideType) {
    <span>Order:</span>
    }{{ labelTxt || docId }}
  </a>
</app-job-detail-preview>
} @if (docType === 'Coil' && idFound) {
<span>
  <a
    class="td-link ml-5"
    [routerLink]="['/inventory/coils', docId]"
    [queryParamsHandling]="preserveQueryParams ? 'preserve' : ''"
  >
    @if (!hideType) {
    <span>Coil:</span>
    }{{ labelTxt || docId }}
  </a>
</span>
} @if (docType === 'PunchPattern' && idFound) {
<app-punch-pattern-preview [patternId]="docId">
  <a
    class="td-link ml-5"
    [routerLink]="['/punching/patterns', docId]"
    [queryParamsHandling]="preserveQueryParams ? 'preserve' : ''"
  >
    @if (!hideType) {
    <span>Pattern:</span>
    }{{ labelTxt || docId }}
  </a>
</app-punch-pattern-preview>
} @if (docType === 'ToolingDef' && idFound) {
<app-tooling-preview [toolingCode]="docId">
  <a
    class="td-link ml-5"
    [routerLink]="['/tooling', docId]"
    [queryParamsHandling]="preserveQueryParams ? 'preserve' : ''"
  >
    @if (!hideType) {
    <span>Tooling:</span>
    }{{ labelTxt || docId }}
  </a>
</app-tooling-preview>
} @if (docType === 'Material' && idFound) {
<!-- Deferred: the preview renders an AG Grid, which must stay out of the initial bundle -->
@defer (on idle) {
<app-coil-type-preview [materialId]="docId">
  <a
    class="td-link ml-5"
    [routerLink]="['/inventory/coil-types', docId]"
    [queryParamsHandling]="preserveQueryParams ? 'preserve' : ''"
  >
    @if (!hideType) {
    <span>Material:</span>
    }{{ labelTxt || docId }}
  </a>
</app-coil-type-preview>
} @placeholder {
<a
  class="td-link ml-5"
  [routerLink]="['/inventory/coil-types', docId]"
  [queryParamsHandling]="preserveQueryParams ? 'preserve' : ''"
>
  @if (!hideType) {
  <span>Material:</span>
  }{{ labelTxt || docId }}
</a>
}
}
<!-- Setups Snapshot : consider uiSref instead of href -->
@if (docType === 'setupsChange') {
<a
  class="td-link"
  href="{{ href }}"
>
  <span>Setups Change: {{ labelTxt }}</span>
</a>
}
